import { InvoiceData } from "@/types";
import { BillingState } from "@/types/store/clientzone";

export const state: BillingState = {
  invoices: [] as Array<InvoiceData>,
  invoicesTotalCount: null
}
